export default {
    namespaced: true,

    state: {
        user: {},
        fetching: false,
    },

    getters: {
        isLoggedIn(state) {
            return typeof state.user !== 'undefined' && state.user && typeof state.user.identifier !== 'undefined';
        },
        getUser(state) {
            return state.user;
        },
    },

    actions: {
        getUser(context) {
            return new Promise((resolve, reject) => {
                if (context.state.fetching) {
                    resolve();
                    return;
                }

                context.commit('setFetching', true);

                window.axios.post('/users/getUser')
                    .then((response) => {
                        context.commit('setUser', response.data.user);
                        context.commit('setFetching', false);
                        resolve(response);
                    })
                    .catch((error) => {
                        context.commit('setFetching', false);
                        reject(error);
                    })
            });
        },
        removePreloader(context) {
            let fadeTarget = document.getElementById('preloader');
            if (fadeTarget) {
                setTimeout(() => {
                    let fadeEffect = setInterval(() => {
                        if (!fadeTarget.style.opacity) {
                            fadeTarget.style.opacity = '1';
                        }
                        if (fadeTarget.style.opacity > 0) {
                            fadeTarget.style.opacity -= '0.5';
                        } else {
                            if (fadeTarget.parentNode !== null) {
                                fadeTarget.parentNode.removeChild(fadeTarget);
                                this.dispatch('application/enableMainScroll');
                            }
                            clearInterval(fadeEffect);
                        }
                    }, 100);
                }, 1500);
            }
        },
        logout(context) {
            return new Promise((resolve, reject) => {
                window.axios.post('/logout')
                    .then((response) => {
                        context.commit('setUser', {});

                        this.commit('application/setCSRFToken', response.data.token);

                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            })
        }
    },

    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setFetching(state, value) {
            state.fetching = value;
        }
    }
}
